
import {
    Box,
    Stack, FormControl, Select,
    MenuItem, InputLabel, Autocomplete, TextField,
    Typography,
    Tabs,
    Tab,
    Avatar
} from "@mui/material";
import { memo, useEffect, useRef, useState } from "react";
import { GetReadOnlyInputProps, Loader } from "../../../HelperFunctions/HelperFunctions";
import americanExpress from "../../../Images/american-express.png"
import chase from "../../../Images/chase.png"
import shift4 from "../../../Images/shift4.png"
import square from "../../../Images/square.png"
import paymentinsider from "../../../Images/payment-insider.png"
import MerchantTabContent from "./MerchantTabContent/MerchantTabContent";
import { useLoaderData, useRouteLoaderData } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { getPCS } from "../../../API/nimbleAPI";
import { getSummaryViewGrid, merchantSummary } from "../../../API/backendAPI";
import MerchantsTable from "./MerchantTabContent/MerchantsTable";


const MerchantsDetails = ({ selectedProfitCenter, setSelectedProfitCenter, setSelectedMerchantProvider, date, setDate }) => {

    const usAmountFormatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const formatUSAmount = (amount) => {
        const normalized = typeof amount === "string" ? amount.replace(/,/g, "") : amount;
        const numericAmount = Number(normalized);
        return Number.isFinite(numericAmount) ? usAmountFormatter.format(numericAmount) : "0.00";
    };

    const widgetBalanceDetails = [
        { label: "As of today", value: "as_of_today" },
        { label: "Month", value: "month" }
    ];

    const { headerCorporation, Previlage } = useLoaderData();
    const isFirstRender = useRef(true);
    const [tabDetails, setTabDetails] = useState([]);
    const [profitCenter, setProfitCenter] = useState([{ ID: "select", Name: "Select profit center" }]);
    // const [selectedProfitCenter, setSelectedProfitCenter] = useState(profitCenter[0]);
    const [widgetBalance, setWidgetBalance] = useState(widgetBalanceDetails[0].value);
    // const tabNames = tabDetails.map(card => card.merchant_provider) || "";
    const [selectedTab, setSelectedTab] = useState(false);
    const [showSummary, setShowSummary] = useState(true);
    const [loading, setLoading] = useState(false);
    // const [date, setDate] = useState(null);
    const [columns, setColumns] = useState([]);
    const [gridData, setGridData] = useState([]);


    useEffect(() => {
        getProfitCenterList();
    }, []);

    useEffect(() => {
        setSelectedMerchantProvider("0");
    }, [selectedProfitCenter?.ID, setSelectedMerchantProvider]);

    useEffect(() => {
        if (typeof selectedTab === "string" && selectedTab.trim()) {
            setSelectedMerchantProvider(selectedTab);
        }
    }, [selectedTab, setSelectedMerchantProvider]);


    useEffect(() => {

        if (!selectedProfitCenter || !widgetBalance || !date) return;

        fetchSummary();
    }, [selectedProfitCenter, widgetBalance, date]);

    useEffect(() => {
        if (!date || !widgetBalance) {
            setColumns([]);
            setGridData([]);
            return;
        }

        fetchdGridData();
    }, [selectedTab, date, widgetBalance]);

    const getProfitCenterList = async () => {

        try {

            if (!headerCorporation) {
                enqueueSnackbar("Please select the corporation to proceed further", { variant: "warning" });
                return;
            }
            setLoading(true);
            const getPCSData = await getPCS(headerCorporation);
            setProfitCenter(getPCSData);

            const defaultPC = getPCSData.length === 2 ? getPCSData[1] : getPCSData[0];
            setSelectedProfitCenter(defaultPC);
            setDate(new Date());

        } catch (error) {
            enqueueSnackbar("Error while getting profit center", { variant: "error" });
        } finally {
            setLoading(false);

        };

    };


    const fetchSummary = async () => {

        if (!headerCorporation) {
            return
        }
        try {
            setLoading(true);

            const payload = {
                corporation_id: headerCorporation,
                pc_id: selectedProfitCenter.ID === "select" ? "" : selectedProfitCenter.ID,
                date: widgetBalance === "as_of_today" ? widgetBalance : "",
                year: widgetBalance === "month" ? date.getFullYear() : null,
                month: widgetBalance === "month" ? date.getMonth() + 1 : null

            };

            const tabValues = await merchantSummary(payload);
            setTabDetails(tabValues);
            if (tabValues?.length === 1) {
                const onlyTab = tabValues[0]?.merchant_provider;

                setSelectedTab(onlyTab);
                setSelectedMerchantProvider(onlyTab || "0");
                setShowSummary(false);
            }
        } catch (err) {
            enqueueSnackbar("Error while refreshing summary", { variant: "error" });
        } finally {
            setLoading(false);
        }
    };


    const fetchdGridData = async () => {
        if (!date) {
            setColumns([]);
            setGridData([]);
            return;
        }

        try {
            setLoading(true);

            const gridPayload = {
                corporation_id: headerCorporation,
                year: date.getFullYear(),
                // month: date.getMonth() + 1,
                month: date ? date.getMonth() + 1 : "",
                profit_center_id: selectedProfitCenter.ID === "select" ? "" : selectedProfitCenter.ID,
                // merchant_provider: selectedTab ?? ""
                merchant_provider: selectedTab === true || selectedTab === false ? "" : selectedTab
            }

            const getGridData = await getSummaryViewGrid(gridPayload);
            const normalizedGridData = Array.isArray(getGridData)
                ? getGridData
                : Array.isArray(getGridData?.rows)
                    ? getGridData.rows
                    : Array.isArray(getGridData?.data)
                        ? getGridData.data
                        : [];

            const dynamicColumns = [
                { dataKey: "date", columnName: "Date", width: "120px" },
                ...Object.keys(normalizedGridData?.[0] ?? {})
                    .filter(k => !["date", "outstanding_balance", "running_balance"].includes(k))
                    .map(k => ({
                        dataKey: k,
                        columnName: k.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase()),
                        width: "100px"
                    })),
                { dataKey: "outstanding_balance", columnName: "Outstanding Balance", width: "150px" },
                { dataKey: "running_balance", columnName: "Running Balance", width: "150px" }
            ];

            setColumns(dynamicColumns);
            setGridData(normalizedGridData);

        } catch (error) {
            enqueueSnackbar("Error while getting Data", { variant: "error" });
        } finally {
            setLoading(false);
        };
    };





    const handleTabChange = (event, newValue) => {
        if (newValue !== selectedTab) {
            setSelectedTab(newValue);
            setSelectedMerchantProvider(newValue || "0");
            setShowSummary(false);
            setColumns([]);
            setGridData([]);
        }
    };

    const TabHeading = memo(({ tab }) => {
        const { merchant_provider, net_amount } = tab;
        const cardIcons = {
            "ameracan express": americanExpress,
            "chase": chase,
            "shift4": shift4,
            "square": square,
            "payment insider": paymentinsider

        };
        const merchantProviderKey = String(merchant_provider || "").trim().toLowerCase();
        return (
            <Stack width="100%" direction="row">
                <Stack width="30%" alignItems="center">
                    <Avatar
                        alt={merchant_provider}
                        src={cardIcons[merchantProviderKey]}
                        sx={{ width: 45, height: 45 }}
                    />
                </Stack>
                <Stack direction="column" alignItems="start" gap={0}>
                    <Typography fontWeight={600} color="text.secondary" fontSize={10}>
                        {merchant_provider}
                    </Typography>
                    <Typography fontWeight={600} color="text.secondary" fontSize={18}>
                        ${formatUSAmount(net_amount)} <span style={{ fontWeight: 600, fontSize: 10 }}>{widgetBalance === "month" ? "Month" : "ATD"}</span>
                    </Typography>
                </Stack>
            </Stack>
        );
    });


    const TabPanel = ({ children, value, tabValue, showSummary }) => {
        // console.log("tabDetails", tabDetails)
        // if (showSummary) return null;
        return value === tabValue || tabDetails.length === 0 ? <Box height={"calc(100% - 75px)"}>{children}</Box> : null;
        // return <Box height={"calc(100% - 75px)"}>{children}</Box>;
    };


    return (
        <>
            <Box component={Stack} height={"100%"} width={"100%"} gap={0.5}>

                <Stack direction={"row"} justifyContent={profitCenter.length > 1 ? "space-between" : "flex-end"}>
                    {profitCenter.length > 1 && <Autocomplete
                        size="small"
                        disableClearable
                        options={profitCenter}
                        value={selectedProfitCenter}
                        onChange={(e, newValue) => setSelectedProfitCenter(newValue)}
                        getOptionLabel={(option) => option.Name}
                        isOptionEqualToValue={(option, value) => option.ID === value.ID}
                        getOptionDisabled={(option) => option.ID === "select"}
                        sx={{ minWidth: 180 }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Profit Center"
                                variant="filled"
                                sx={{
                                    "& .MuiInputBase-root": {
                                        height: 35,
                                    },
                                }}
                                {...(
                                    ["Select profit center"].includes(params.inputProps?.value)
                                    && GetReadOnlyInputProps(params)
                                )}
                            />
                        )}
                    />}

                    <FormControl
                        variant="filled"
                        size="small"
                        sx={{
                            minWidth: "150px",
                        }}
                    >
                        <InputLabel>Widget balances</InputLabel>
                        <Select
                            value={widgetBalance}
                            onChange={(e) => {
                                if (!Previlage?.[0].Create) {
                                    enqueueSnackbar("You do not have sufficient privileges to perform this action", { variant: "warning" });
                                    return;
                                }
                                setTabDetails([]);
                                setWidgetBalance(e.target.value);

                            }}
                            label="Widget balances"
                            sx={{
                                height: "35px",

                            }}
                        >
                            {widgetBalanceDetails.map((option) => (
                                <MenuItem
                                    key={option.value}
                                    value={option.value}
                                >
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Stack>

                <Box height={"calc(100% - 30px)"}>
                    <Tabs
                        value={selectedTab || false}
                        onChange={handleTabChange}
                        variant={
                            tabDetails.length > 4
                                ? "scrollable"
                                : tabDetails.length > 2
                                    ? "fullWidth"
                                    : "standard"
                        }
                        centered={tabDetails.length < 3}
                        scrollButtons={tabDetails.length > 4 ? "auto" : false}
                        TabIndicatorProps={{ style: { display: "none" } }}
                        sx={{
                            maxHeight: "71px",
                            borderRadius: 2,
                            border: tabDetails.length <= 2 ? null : "1px solid #d7d7d7",
                            "& .MuiTab-root": {
                                textTransform: "none",
                                fontSize: 14,
                                "&:not(:last-child)": {
                                    borderRight: "1px solid #d7d7d7",
                                },
                                minWidth:
                                    tabDetails.length < 3
                                        ? 300
                                        : tabDetails.length <= 4
                                            ? "auto"
                                            : 250,
                                ...(tabDetails.length <= 2 && {
                                    border: "1px solid #d7d7d7",
                                    "&:first-of-type": {
                                        borderTopLeftRadius: "8px",
                                        borderBottomLeftRadius: "8px",
                                    },
                                    "&:last-of-type": {
                                        borderTopRightRadius: "8px",
                                        borderBottomRightRadius: "8px",
                                        // borderLeft: "none",
                                    },
                                    ...(tabDetails.length === 2 && {
                                        "&:last-of-type": {
                                            borderLeft: "none",
                                            borderTopRightRadius: "8px",
                                            borderBottomRightRadius: "8px",
                                        },
                                    }),
                                }),
                            },
                            "& .Mui-selected": {
                                backgroundColor: !showSummary && "#bee9e9",
                                color: "black !important",
                            },
                        }}
                    >
                        {tabDetails.map((tab) => (
                            <Tab
                                key={tab.merchant_provider}
                                value={tab.merchant_provider}
                                label={<TabHeading tab={tab} />}
                                onClick={(e, v) => {
                                    if (tab.merchant_provider === selectedTab) {
                                        setSelectedTab(v);
                                        setShowSummary((prev) => !prev);
                                        setColumns([]);
                                        setGridData([]);
                                        setSelectedMerchantProvider(tab.merchant_provider || "0");
                                    }
                                }}
                            />
                        ))}
                    </Tabs>

                    {

                        showSummary ? (
                            <Box height={"calc(100% - 75px)"}>
                                <MerchantTabContent
                                    date={date}
                                    setDate={setDate}
                                    columns={columns}
                                    rows={gridData}
                                    selectedProfitCenter={selectedProfitCenter}
                                    selectedMerchantProvider={selectedTab}
                                />
                            </Box>
                        ) : (
                            tabDetails.map((tab) => (
                                <TabPanel
                                    key={tab.merchant_provider}
                                    value={selectedTab}
                                    tabValue={tab.merchant_provider}
                                    showSummary={showSummary}
                                >
                                    <MerchantTabContent
                                        tab={tab}
                                        date={date}
                                        setDate={setDate}
                                        columns={columns}
                                        rows={gridData}
                                        selectedProfitCenter={selectedProfitCenter}
                                        selectedMerchantProvider={selectedTab}
                                    />
                                </TabPanel>
                            ))
                        )
                    }
                </Box>

            </Box>
            {loading && <Loader loading={loading} />}
        </>
    )


};

export default MerchantsDetails;